import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Pdf from "react-to-pdf";

import {
  PerPatient,
  PerDepartment,
  PerWasteType,
  PerMealCategory,
  PerPeriod,
  SpreadWeekdays,
} from "./";
import { DashboardFilter } from "../../components";

const CustomerDashboard = ({ user }) => {
  // Declare variables
  function setToMonday( date ) {
      var day = date.getDay() || 7;
      if( day !== 1 )
          date.setHours(-24 * (day - 1));
      return date;
  }

  const ref = React.createRef();
  const [options, setOptions] = useState({
    orientation: 'landscape',
    unit: 'px',
    format: [1920,1080]
  });
  const [x, setX] = useState(0.5);
  const [y, setY] = useState(0.5);

  const pdfButton = (<Pdf targetRef={ref} x={x} y={y} options={options} filename="cc_rapport.pdf">
          {({toPdf}) => (
              <button className="dashboard__filter__exportbutton" onClick={toPdf}>EXPORT</button>
          )}
        </Pdf>);

  const monday_date = setToMonday(new Date())
  const last_date = new Date(monday_date).setDate(monday_date.getDate() + 6)


  const [formStep, setFormstep] = useState(0);
  const [locations, setLocations] = useState();
  const [customers, setCustomers] = useState();
  const [customerId, setCustomerId] = useState();
  const [departmentId, setDepartmentId] = useState(0);
  const [startDate, setStartDate] = useState(monday_date);
  const [endDate, setEndDate] = useState(last_date);
  const locationId = user.location_id;

  useEffect(() => {
    if(locationId > 0) {
      let box = document.querySelector('.dashboard__container');
      let width = box.offsetWidth;
      let height = box.offsetHeight;
      setX(width/20)
      setY(height/20)
      setOptions({
        orientation: 'landscape',
        unit: 'px',
        format: [width,height]
      })
    }
  }, [locationId])

  // 0 = grams, 1 = euro's
  const [filter, setFilter] = useState(0);

  const stepTitle = {
    0: {
      key: "Zorgbehoevende",
      value: "Gemiddelde derving per zorgbehoevende in gemeten periode",
    },
    1: {
      key: "Afdeling",
      value: "Totale derving op afdeling in gemeten periode",
    },
    2: {
      key: "Periode",
      value: "Totale derving per dag in gemeten periode",
    },
    3: {
      key: "Maaltijd component",
      value: "Derving per maaltijd component in gemeten periode",
    },
    4: {
      key: "Reden derving",
      value: "Totale verspilling per dervingsreden",
    },
    5: {
      key: "Verspreiding weekdagen",
      value: "Verspreiding derving over weekdagen gemiddeld per bewoner",
    },
  };

  const _next = () => {
    if (formStep < 5) {
      setFormstep(formStep + 1);
    } else {
      console.log("return to first dash");
    }
  };

  return (
    <div className="container">
      <h2 className="container__title">{stepTitle[formStep].value}</h2>
      <div className="form__container">
        <div className="form__container__tabs">
          {Object.keys(stepTitle).map((key) => {
            let classname = "form__container__tabs__step";
            if (key == formStep) classname += " step__active";
            return (
              <span onClick={() => setFormstep(key)} className={classname}>
                {stepTitle[key].key}
              </span>
            );
          })}
        </div>
        <DashboardFilter
          filter={filter}
          formStep={formStep}
          setFilter={setFilter}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          locationId={locationId}
          pdfButton={pdfButton}
          departmentId={departmentId}
          setDepartmentId={setDepartmentId}
        />

        <div className="dashboard__container" ref={ref}>
        {formStep == 0 && (
          <PerPatient
            customerId={customerId}
            startDate={startDate}
            endDate={endDate}
            filter={filter}
            locationId={locationId}
          />
        )}
        {formStep == 1 && (
          <PerDepartment
            customerId={customerId}
            startDate={startDate}
            endDate={endDate}
            filter={filter}
            locationId={locationId}
          />
        )}
        {formStep == 2 && (
          <PerPeriod
            customerId={customerId}
            startDate={startDate}
            endDate={endDate}
            filter={filter}
            locationId={locationId}
          />
        )}
        {formStep == 3 && (
          <PerMealCategory
            startDate={startDate}
            endDate={endDate}
            filter={filter}
            departmentId={departmentId}
            locationId={locationId}
          />
        )}
        {formStep == 4 && (
          <PerWasteType
            customerId={customerId}
            startDate={startDate}
            endDate={endDate}
            filter={filter}
            locationId={locationId}
          />
        )}
        {formStep == 5 && (
          <SpreadWeekdays
            customerId={customerId}
            startDate={startDate}
            endDate={endDate}
            filter={filter}
            locationId={locationId}
          />
        )}
        </div>
      </div>
    </div>
  );
};

export default CustomerDashboard;
